import { NgModule } from '@angular/core';
import { AnyPipe } from './any.pipe';
import { EllipsisPipe } from './ellipsis.pipe';
import { ExpandAkaPipe } from './expand-aka.pipe';
import { IncompletePipe } from './incomplete.pipe';
import { LineBreakPipe } from './line-break.pipe';
import { LocaleDatePipe } from './locale-date.pipe';
import { SafeUrlPipe } from './safe-url.pipe.ts';

const PIPES = [AnyPipe, EllipsisPipe, ExpandAkaPipe, IncompletePipe, LineBreakPipe, LocaleDatePipe, SafeUrlPipe];

@NgModule({
	declarations: [PIPES],
	exports: [PIPES],
	providers: [PIPES],
})
export class SharedPipesModule {}
